import { ChangeDetectionStrategy, Component } from '@angular/core';
import { JsonLdService, MetaService } from '@app/core';
import { PARTNERS_FAQS } from '../../constants';
import {
  PartnersBenefitsSectionComponent,
  PartnersCtaSectionComponent,
  PartnersFaqSectionComponent,
  PartnersHeroSectionComponent,
} from '../index';

@Component({
  selector: 'app-partners',
  imports: [
    PartnersHeroSectionComponent,
    PartnersBenefitsSectionComponent,
    PartnersFaqSectionComponent,
    PartnersCtaSectionComponent,
  ],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersComponent {
  constructor(
    private readonly metaService: MetaService,
    private readonly jsonLdService: JsonLdService,
  ) {
    this.metaService.setDescription(
      'Join the Capawesome Partner Network and unlock exclusive benefits, priority support, and co-marketing opportunities to grow your business with mobile app solutions.',
    );
    this.metaService.setTitle('Become a Capawesome Partner - Partner Program');
    this.metaService.setKeywords([
      'Capacitor partner program',
      'mobile app development partner',
    ]);
    this.jsonLdService.setStructuredData([
      JsonLdService.buildWebPageSchema(
        'Partner Program - Capawesome Cloud',
        'Join the Capawesome Partner Network and unlock exclusive benefits.',
        'https://cloud.capawesome.io/partners/',
      ),
      JsonLdService.buildFaqSchema(PARTNERS_FAQS),
    ]);
  }
}
